import { render } from "./Cookies.vue?vue&type=template&id=c4e547dc&scoped=true"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"

import "./Cookies.vue?vue&type=style&index=0&id=c4e547dc&lang=scss"
import "./Cookies.vue?vue&type=style&index=1&id=c4e547dc&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1072429318/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4e547dc"]])

export default __exports__